"use strict";

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var config_1 = require("../../../config");

var StaticMapService =
/*#__PURE__*/
function () {
  function StaticMapService() {
    _classCallCheck(this, StaticMapService);
  }

  _createClass(StaticMapService, [{
    key: "getImageryAtPoint",
    value: function getImageryAtPoint(options) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var url = _this.getImageryURLAtPoint(options);

        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };

        img.onerror = function () {
          reject(new Error("failed to retrieve map image at url ".concat(url)));
        };

        img.src = url;
      });
    }
  }], [{
    key: "GetService",
    value: function GetService() {
      if (StaticMapService.cachedService == null) {
        var config = config_1.getConfig();

        if (config.MapService) {
          switch (config.MapService.provider) {
            case "Google":
              {
                StaticMapService.cachedService = new GoogleMapService(config.MapService.apiKey);
              }
              break;

            case "Bing":
              {
                StaticMapService.cachedService = new BingMapService(config.MapService.apiKey);
              }
              break;
          }
        }
      }

      return StaticMapService.cachedService;
    }
  }]);

  return StaticMapService;
}();

StaticMapService.cachedService = null;
exports.StaticMapService = StaticMapService;

function buildQueryParameters(options) {
  var r = [];

  for (var p in options) {
    if (options.hasOwnProperty(p)) {
      r.push(encodeURIComponent(p) + "=" + encodeURIComponent(options[p]));
    }
  }

  return r.join("&");
}

var GoogleMapService =
/*#__PURE__*/
function (_StaticMapService) {
  _inherits(GoogleMapService, _StaticMapService);

  function GoogleMapService(apiKey) {
    var _this2;

    _classCallCheck(this, GoogleMapService);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GoogleMapService).call(this));
    _this2.apiKey = apiKey;
    return _this2;
  }

  _createClass(GoogleMapService, [{
    key: "getImageryURLAtPoint",
    value: function getImageryURLAtPoint(options) {
      var params = {
        center: "".concat(options.center.latitude, ",").concat(options.center.longitude),
        zoom: "".concat(options.zoom),
        size: "".concat(options.width, "x").concat(options.height),
        key: this.apiKey,
        format: "png"
      };

      if (options.resolution == "high") {
        params.scale = "2";
      }

      if (options.type == "satellite") {
        params.maptype = "satellite";
      }

      if (options.type == "hybrid") {
        params.maptype = "hybrid";
      }

      if (options.type == "terrain") {
        params.maptype = "terrain";
      }

      var url = "https://maps.googleapis.com/maps/api/staticmap";
      url += "?" + buildQueryParameters(params);
      return url;
    }
  }]);

  return GoogleMapService;
}(StaticMapService);

exports.GoogleMapService = GoogleMapService;

var BingMapService =
/*#__PURE__*/
function (_StaticMapService2) {
  _inherits(BingMapService, _StaticMapService2);

  function BingMapService(apiKey) {
    var _this3;

    _classCallCheck(this, BingMapService);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(BingMapService).call(this));
    _this3.apiKey = apiKey;
    return _this3;
  }

  _createClass(BingMapService, [{
    key: "getImageryURLAtPoint",
    value: function getImageryURLAtPoint(options) {
      var params = {
        mapSize: "".concat(options.width, ",").concat(options.height),
        key: this.apiKey,
        format: "png"
      };

      if (options.resolution == "high") {
        params.dpi = "Large";
        params.mapSize = "".concat(options.width * 2, ",").concat(options.height * 2);
      }

      var type = "Road";

      if (options.type == "satellite") {
        type = "Aerial";
      }

      if (options.type == "hybrid") {
        type = "AerialWithLabels";
      }

      var url = "https://dev.virtualearth.net/REST/v1/Imagery/Map/".concat(type, "/");
      url += "".concat(options.center.latitude, ",").concat(options.center.longitude, "/").concat(options.zoom + 1);
      url += "?" + buildQueryParameters(params);
      return url;
    }
  }]);

  return BingMapService;
}(StaticMapService);

exports.BingMapService = BingMapService;